import { render } from "./ApplicationSchool.vue?vue&type=template&id=42d23230"
import script from "./ApplicationSchool.vue?vue&type=script&lang=js"
export * from "./ApplicationSchool.vue?vue&type=script&lang=js"

import "./ApplicationSchool.vue?vue&type=style&index=0&id=42d23230&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__